import { Component } from '@angular/core';
import { NavbarComponent } from "../../partials/navbar/navbar.component";
import { FooterComponent } from "../../partials/footer/footer.component";
import { Title } from '@angular/platform-browser';
import { LanguageService } from '../../services/language.service';

@Component({
  selector: 'app-terms-conds-page',
  standalone: true,
  imports: [NavbarComponent, FooterComponent],
  templateUrl: './terms-conds-page.component.html',
  styleUrl: './terms-conds-page.component.css'
})
export class TermsCondsPageComponent {
  texts: any;
  constructor(private langService:LanguageService, private title:Title){
    this.texts = this.langService.getWebisteTexts().privacy_policy;
  
    if (this.langService.getLanguage() == 'es') {
      this.title.setTitle('PRINX - Política de privacidad') 
    }else{
      this.title.setTitle('PRINX - Privacy policy')
    }
  }
}
